module.exports = __webpack_public_path__ + "img/nav_icon_fetal.c2b0e0b2.svg";